import { useEffect } from 'react';

import { IUseAlertOrderLimit } from './types';

const useAlertOrderLimit = ({
  calculateCartTotal,
  alertOrderLimit,
  checkoutPriceLimit,
  setCartPriceLimitExceeded,
  isCatering,
}: IUseAlertOrderLimit) => {
  useEffect(() => {
    if (!isCatering && calculateCartTotal() > checkoutPriceLimit) {
      alertOrderLimit();
      setCartPriceLimitExceeded(true);
      return;
    }

    setCartPriceLimitExceeded(false);
  }, [
    calculateCartTotal,
    alertOrderLimit,
    checkoutPriceLimit,
    isCatering,
    setCartPriceLimitExceeded,
  ]);
};

export default useAlertOrderLimit;
